var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCitationGeneratorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "citation-icon",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.81 21.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.81,5.35h0c-2.42.65-4.69,2.93-5.35,5.35h0c-.65-2.42-2.93-4.69-5.35-5.35h0c2.42-.65,4.69-2.93,5.35-5.35h0c.65,2.42,2.93,4.69,5.35,5.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9.06,
    width: 9.91,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.47,
    width: 16.18,
    height: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16.61h6.27v-2.35H0v2.35ZM8.27,14.26v2.35h11.55v-2.35h-11.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitationGeneratorIcon);
export default __webpack_public_path__ + "static/media/citation-generator-icon.b2efc652fa08aff3e68585f20db08ae0.svg";
export { ForwardRef as ReactComponent };